import { Resources } from 'constants/resources';

import { hydraSchemaAnalyzer } from '@api-platform/admin';
import { queryClient } from 'providers/queryClient';
import { HttpError, useNotify, useRedirect, useUpdate } from 'react-admin';
import { BankOperation } from 'types/embedded/bankOperation';
import { formatInputToTimestamp } from 'utils/date';
import { getId } from 'utils/getId';

type Result = {
  updateBankOperation: (data: BankOperation) => void;
};

export function useUpdateBankOperation(setErrors: (e: any) => void): Result {
  const notify = useNotify();

  const redirect = useRedirect();

  const [update] = useUpdate<BankOperation>(Resources.RequestBankOperations);

  const updateSingle = (data: BankOperation) => {
    return update(
      Resources.RequestBankOperations,
      {
        id: data.id,
        data: {
          ...data,
          dateOfOperation:
            formatInputToTimestamp(data.dateOfOperation, { unit: 'seconds' }) || undefined,
          description: data.description || '',
          amountPenny: data.amountPenny.toString(),
        },
      },
      {
        onError: (e: any) => {
          const violations = hydraSchemaAnalyzer().getSubmissionErrors(e as HttpError);
          setErrors(violations);
        },
        onSuccess: async () => {
          await queryClient.invalidateQueries({ queryKey: [Resources.RequestBankOperations] });
          redirect('list', Resources.RequestBankOperations);

          notify(`Заявка на банковскую операцию ID ${getId(data?.id)} изменена`, {
            type: 'success',
          });
        },
      },
    );
  };

  return {
    updateBankOperation: updateSingle,
  };
}
